export enum CharacterType {
  VILLAIN = 'VILLAIN',
  HERO = 'HERO',
}
